<template lang="pug">
#App
  Header(:style="{ color: $store.state.loaderIsVisible ? $store.state.colors.light : ($store.getters.lightHeader ? $store.state.colors.light : $store.state.colors.dark) }" :isMobile="!displayable")
  template(v-if="displayable")
    Loader
    router-view
    CustomCursor
  section.mobile(v-else)
    h1.title {{$t('look_further')}}
    p.time
      img(src="./assets/images/mobile-2020x2.png")
    .go-to-desktop
      p {{$t('open_on_desktop')}}
      ShareBtn.sharebtn(:text="$t('share_message')")
</template>

<script>
import Header from '@/components/Header'
import CustomCursor from '@/components/CustomCursor'
import cardsData from '@/assets/data/cards'
import decorationsData from '@/assets/data/decoration'
import Loader from '@/components/Loader'
import ShareBtn from '@/components/ShareBtn'
import { TextureLoader, PlaneGeometry, MeshBasicMaterial, Mesh } from 'three'

const loader = new TextureLoader()

export default {
  name: 'app',
  components: { Header, CustomCursor, Loader, ShareBtn },
  data () {
    return {
      displayable: false
    }
  },
  mounted () {
    this.$store.commit('setCards', cardsData.map(card => {
      const texture = loader.load(card.cover)
      const geometry = new PlaneGeometry(card.size.width, card.size.height, 1, 1)
      const material = new MeshBasicMaterial({ map: texture })
      const mesh = new Mesh(geometry, material)
      mesh.position.set(card.stackedPosition.x, card.stackedPosition.y, 0)

      return { ...card, mesh, hasBeenVisited: false }
    }))

    this.$store.commit('setDecorations', decorationsData.map(decoration => {
      const texture = loader.load(decoration.cover)
      const geometry = new PlaneGeometry(decoration.size.width, decoration.size.height, 1, 1)
      const material = new MeshBasicMaterial({ map: texture, transparent: true, opacity: 1 })
      const mesh = new Mesh(geometry, material)
      mesh.position.set(decoration.stackedPosition.x, decoration.stackedPosition.y, 0)

      return { ...decoration, mesh }
    }))

    this.displayable = window.innerWidth > this.$store.state.minWidth
    window.addEventListener('resize', () => { this.displayable = window.innerWidth > this.$store.state.minWidth })
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
  font-family: $font;
  font-weight: normal;
  overflow: hidden;

  --pink: #{$pink};
  --black: #{$black};
  --white: #{$white};

  --font: #{$font};
  --font-rz: #{$font-rz};
  --font-grand: #{$font-grand};
  --font-v: #{$font-v};

  h1, h2, h3, h4, h5, h6 {
    font-weight: normal;
  }
}

.mobile {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: $black;
  color: $white;
  font-family: $font-rz;
  text-align: center;
  padding-top: 0;

  .title {
    font-size: 18px;
    font-weight: normal;
  }

  .time {
    font-family: $font-grand;
    font-weight: 800;
    font-size: 20vw;
    margin: 20px 0 40px 0;
    /*height: 24vh;*/

    img {
      width: 80vw;
      height: auto;
      padding: 0 10vw;
      object-fit: contain;
      object-position: center center;
      /*position: absolute;*/
      display: block;
      top: 0;
      left: 0;
      max-width: 410px;
    }
  }

  .go-to-desktop {
    font-size: 14px;
    max-width: 246px;
    line-height: 1.618;

    .sharebtn {
      margin: 15px;
    }
  }
}
</style>
